<script>
  import { DateTime } from 'luxon';
  import standardizeDate from '../../../helpers/standardizeDate';

  export let day;
  export let blocks;
  export let user;
  export let currency = '';
  export let height;

  let tooltipX = 0;
	let tooltipY = 0;

  const handleMouseOver = (e) => {
		tooltipX = e.clientX;
		tooltipY = e.clientY;
  };

	const isWeekend = date => date.weekday === 4 || date.weekday === 5;

	const isBlocked = (date) => {
    const _date = standardizeDate(new Date(date.ts));
		return blocks.find(block => _date === block.day.substring(0,10));
  };


  const isAfterBlock = (date) => {
    const _date = standardizeDate(DateTime.fromMillis(date.ts).minus({days:1}).toJSDate());
		return blocks.find(block => _date === block.day.substring(0,10));
  };


  const getService = (day) => {
    let service = null;
    if (day.checkout) { service = day.checkout };
    if (day.touchup)  { service = day.touchup };
    if (day.midstay)  { service = day.midstay };
    if (day.deepclean){ service = day.deepclean };


    return service;
  };

  $: service = getService(day);

</script>

<div class='day' style='height: {height}px;'
  class:cleaner='{user.accountRole.toLowerCase() === 'cleaner'}'
  class:isWeekend='{isWeekend(day.date)}'
  class:touchup='{day.touchup}'
  class:checkout='{day.checkout}'
  class:midstay='{day.midstay}'
  class:deepclean='{day.deepclean}'
  class:isBlocked='{isBlocked(day.date)}'
  class:isAfterBlock='{isAfterBlock(day.date)}'
  on:mousemove={handleMouseOver} >
  {#if service && user.accountRole.toLowerCase() === 'cleaner'}
    <span class='tip cleaner'  style='left: {tooltipX}px; top:{tooltipY}px'>
      <p class='blue-font'><b>Check-out: {DateTime.fromISO(service.dateScheduled,{setZone : true}).toLocaleString()}</b></p>
      {#if service.bookingId}
      <p class='name'><b>{service.bookingId.guestFirstName} {service.bookingId.guestLastName}</b></p>
      <p>{service.bookingId.numberOfGuests} guests</p>
      {/if}
      {#if service.airbetterId.wifinetwork}
      <p class='name'> Wifi Network : {service.airbetterId.wifinetwork}</p>
      {/if}

      {#if service.airbetterId.wifipassword}
      <p class='name'> Wifi Password : {service.airbetterId.wifipassword}</p>
      {/if}

      {#if service.description}
        <p class='pink-font'><b>{service.description}</b></p>
      {/if}
      <p>Type: {service.subtypeId.name}</p>
      <p>Time: {service.dateScheduled.split('T')[1].substring(0,5)}</p>
    </span>
  {/if}
  {#if day.price}
    <span class='price'>{day.price.public_price}<br/> {currency}</span>
  {/if}
</div>

<style>
  .day{
		display: block;
		width:50px;
		border-right:1px solid #DDDDDD;
		position: relative;
	}

	.day.isWeekend {
		background-color: #FDE9EB;
		opacity: .7;
	}

  .day .price {
		font-size: 13px;
		color: #F04066;
		width:50px;
		margin-top:8px;
		overflow: hidden;
		text-align: center;
		display: none;
	}

  .day.isBlocked .price {
		display: none
	}

	.day.checkout .price, .day.isAfterBlock .price {
		width:40px;
		border-radius: 50%;
		background-color: white;
		height:34px;
		font-size:10px;
		margin:5px;
		position: relative;
		z-index: 4;
		box-shadow: 0 0 6px #999;
		padding: 6px 0 0;
	}

	.day.cleaner.checkout,
	.day.cleaner.midstay,
	.day.cleaner.deepclean,


	.day.cleaner.touchup{
		background-position: center;
		background-repeat:no-repeat;
		z-index: 1
	}

	.day.cleaner.checkout {
		background-color:#EF4064;
		background-image:url(/img/checkout.png);
	}

	.day.cleaner.midstay {
		background-color:#42ACAD;
		background-image:url(/img/midstay.png);
	}

	.day.cleaner.touchup {
		background-color:#42ACAD;
		background-image:url(/img/touch-up.png);
	}

	.day.cleaner.deepclean {
		background-color:#EF4064;
		background-image:url(/img/deep-clean.png);
	}

  .tip {
		font-style: normal;
		text-transform: none;
		text-align: left;
		border: 1px solid #D0CFCB;
		background-color: white;
		position: fixed;
		padding: 10px;
		z-index: 5;
		display: none;
		width:200px;
		transform: translateX(-50%) translateY(-120%);
		color:black;
		font-size:13px;
		line-height:20px;
		font-weight:normal;
	}
	.tip p{
		margin:0;
	}
	.tip p.name{
		font-size:14px;
		margin:4px 0;
	}

  .day:hover .tip {
    display: block;
  }

	.tip::before{
		width: 0;
		height: 0;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-top: 10px solid #D0CFCB;
		content: " ";
		position: absolute;
		bottom:-10px;
		left:100px;
	}

	.tip::after{
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-top: 9px solid white;
		content: " ";
		position: absolute;
		bottom:-9px;
		left:102px;
	}
</style>
